import { getContext } from '../components/core/Page/context'
import { useEmitter } from '~/composables/core/useEmitter'

const state = {
	leavingSlug: null,
	leavingNode: null,
	leavingDone: null,
}

export const pageTransition = {
	name: 'default',
	mode: 'in-out',
	css: false,
	onLeave: (node, done) => {
		const slug = node.getAttribute('data-slug')
		const emitter = useEmitter()

		state.leavingSlug = slug
		state.leavingNode = node
		state.leavingDone = done

		console.log('leave')
		emitter.emit('scroller-lock')

		console.log(`⚙︎ [${slug}]  leave from dom`)
	},
	onEnter: (nextNode) => {
		const slug = nextNode.getAttribute('data-slug')
		const leaveNode = state.leavingNode
		const leavingSlug = state.leavingSlug
		const done = state.leavingDone
		const prevContext = getContext(leavingSlug || 'page')
		const context = getContext(slug)

		nextNode.style.cssText = `position:fixed; top: 0px; z-index: 0; width: 100%; overflow: hidden; opacity: 0;`

		console.log('enter')
		document.querySelector(':root').style.setProperty('--initial-100vh', `${window.innerHeight}px`)

		if (!context) {
			done && done()
			state.leavingSlug = null
			state.leavingNode = null
			state.leavingDone = null
			return
		}

		Promise.all([context.loader.mounted, context.loader.loaded])
			.then(() => {
				console.log(`⚙︎ [${slug}] all critical assets loaded, animating.`)

				setTimeout(() => {
					const runEnter = () => context.methods.transitionEnter(nextNode, done)

					if (!prevContext || !leaveNode) {
						done && done()
						runEnter()
						return
					}

					prevContext.methods.transitionLeave(leaveNode, done).then(() => runEnter())
				}, 250)
			})
			.catch(() => {
				done && done()
			})

		state.leavingSlug = null
		state.leavingNode = null
		state.leavingDone = null
	},
}

export default pageTransition
